import parse from 'html-react-parser';
import picblock from '../Components/PicBlock';

let bodyStyle = {
    backgroundImage: `url(/doujinarchive/img/windowbg.jpg)`,
    backgroundRepeat: `no-repeat`
};

let ww = window.innerWidth;

export default function BlogWin(props) {
    const copyLink = () => {
        navigator.clipboard.writeText(`https://btuberbilly.github.io/doujinarchive?post=${props.game.postID}`);
    }

    let postH = <table className="header-table"><tr className="header-row">
    <td>
        <img alt="cover art" className={(props.game.crispy) ? "cover-art crispy" : "cover-art"} onClick={copyLink} src={`/doujinarchive/img/${props.game.fileName}`} />
    </td>
    <td className="game-info">
        <h1>{props.game.title}</h1>
        {(props.game.subtitle) ? <h5>{props.game.subtitle}</h5> : ""}
        <h6 className="maker">{(props.game.circle) ? `${props.game.circle}, ` : ``}{props.game.year}</h6>
        {props.game.para.map(para => {
            return(<p className='description'>{parse(para)}</p>)
        })}
        <picblock image="aruki.gif" quote="Multi's walking animation. Cute!"/>
    </td>
</tr></table>;

    let postV =
        <table className="header-table">
            <tr className="header-row">
                <td>
                    <img alt="cover art" className={(props.game.crispy) ? "cover-art crispy" : "cover-art"} onClick={copyLink} src={`/doujinarchive/img/${props.game.fileName}`}/>
                </td>
            </tr>
            <tr>
                <td className="game-info">
                    <h1>{props.game.title}</h1>
                    {(props.game.subtitle) ? <h5>{props.game.subtitle}</h5> : ""}
                    <h6 className="maker">{(props.game.circle) ? `${props.game.circle}, ` : ``}{props.game.year}</h6>
                    {props.game.para.map(para => {
                        return(<p className='description'>{parse(para)}</p>)
                    })}
                </td>
            </tr>
        </table>;

    return(
        <div className="window">
            <div className="window-title">
                <img alt="window icon" src={`/doujinarchive/ico/page.png`} className="window-icon" onClick={copyLink}/>
                {(props.game.subtitle) ? props.game.subtitle : props.game.title}
            </div>
            <div className="window-body" style={bodyStyle}>
                    {(ww > 480) ? postH : postV}
                <div className="controls">
                    {props.game.buttons.map(btn => {
                        return(<a href={btn.url}><button>{btn.title}</button></a>)
                    })}
                </div>
            </div>
        </div>
    );
}